// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--color-card-text);
  border: none;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/errors/error.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AACF","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  color: var(--color-card-text);\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
